import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { MeasurementUnit } from 'app/mdm/terminology-lib/services/measurement-unit';

@Injectable()
export class MeasurementUnitService {
  private baseUrl = `${environment.mdmApi}/measurement-units`;

  constructor(private http: HttpClient) {}

  public save(measurementUnit: MeasurementUnit, id: number): Observable<MeasurementUnit> {
    if (id) {
      return this.http.put<MeasurementUnit>(this.baseUrl + '/' + id, measurementUnit);
    }
    return this.http.post<MeasurementUnit>(this.baseUrl, measurementUnit);
  }
}
